export default "__VITE_ASSET__BzkHVpnn__"